module.exports = __webpack_public_path__ + "static/img/index3.a94885d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index3.gif
// module id = 1U1V
// module chunks = 0